import { render, staticRenderFns } from "./MdMenuContent.vue?vue&type=template&id=13075457"
import script from "./MdMenuContent.vue?vue&type=script&lang=js"
export * from "./MdMenuContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports